var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaymentAmex = function SvgIconPaymentAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_payment_amex_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.237 0H2.763C1.197 0 0 1.192 0 2.75v16.5C0 20.808 1.29 22 2.763 22h29.474C33.803 22 35 20.808 35 19.25V2.75C35 1.192 33.71 0 32.237 0",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "M32.238.917c1.013 0 1.842.825 1.842 1.833v16.5a1.843 1.843 0 0 1-1.842 1.833H2.764A1.843 1.843 0 0 1 .922 19.25V2.75c0-1.008.829-1.833 1.842-1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.273 18.275v-7.72l13.805.012V12.7l-1.595 1.697 1.595 1.712v2.177H31.53l-1.353-1.487-1.345 1.492-8.559-.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "M21.195 17.428v-6.023h5.132v1.387h-3.47v.942h3.387v1.364h-3.387v.926h3.47v1.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "m26.3 17.428 2.84-3.015-2.84-3.009h2.198l1.736 1.91 1.74-1.909h2.103v.047l-2.779 2.96 2.78 2.931v.086h-2.126L30.187 15.5l-1.748 1.929H26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.917 3.703h3.329l1.169 2.641v-2.64h4.108l.709 1.978.71-1.979h3.137v7.72H17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "m21.55 4.542-2.687 6.019h1.842l.507-1.206h2.745l.506 1.206h1.888l-2.674-6.019zm.23 3.462.805-1.916.804 1.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "M26.324 10.56V4.54l2.59.01 1.333 3.7 1.341-3.709h2.49v6.018l-1.602.015V6.44l-1.514 4.12h-1.465l-1.543-4.134v4.134h-1.629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_payment_amex_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v22H0z"
  })))));
};
export default SvgIconPaymentAmex;